import {
  FilterOperationType,
  FilterType,
} from '@/components/Table/Table.constants';
import type { Filter } from '@/components/Table/Table.types';

import { LOSTypeValues } from '../CustomPopulation.constants';
import type { CustomPopulation } from '../CustomPopulation.types';

type LOSValues = Pick<
  CustomPopulation['filters'],
  'los' | 'losRangeEnd' | 'losRangeStart' | 'losRangeType' | 'losType'
>;

export const formatLOSFilter = (
  values: Nullable<LOSValues>,
  _propertyName: string
): Nullable<Filter> => {
  if (!values?.los) return null;

  const { los, losRangeEnd, losRangeStart, losRangeType, losType } = values;

  const resolvedPropertyName =
    losType === LOSTypeValues.HOURS
      ? 'length_of_stay_hours'
      : 'length_of_stay_days';

  // RANGE CASE
  if (los.includes('range') && losRangeType) {
    if (losRangeType === FilterOperationType.BETWEEN) {
      return {
        operationType: FilterOperationType.BETWEEN,
        propertyName: resolvedPropertyName,
        type: FilterType.TEXT,
        value: `-,${losRangeStart},${losRangeEnd}`,
      };
    }

    return {
      operationType: losRangeType,
      propertyName: resolvedPropertyName,
      type: FilterType.TEXT,
      value: `_,${losRangeStart}`,
    };
  }

  // NON-RANGE CASE
  return {
    operationType: FilterOperationType.EQUALS,
    propertyName: resolvedPropertyName,
    type: FilterType.TEXT,
    value: los,
  };
};
